import { PanelMenuDesignTokens } from "@primeuix/themes/types/panelmenu";
import { primitiveColorTokens, primitiveFontTokens, primitiveLayoutTokens } from "src/assets/layout/styles/tokens";

export const panelmenu: PanelMenuDesignTokens = {
    item: {
        borderRadius: primitiveLayoutTokens.borderRadius,
        focusBackground: primitiveColorTokens.grey[400],
        color: primitiveColorTokens.blue[700],
        focusColor: primitiveColorTokens.blue[700],
        icon: {
            color: primitiveColorTokens.blue[700],
        },
    },
    css: () => {
        /**
         * Base Overrides for p-panelmenu
         * NOTE - BS - PrimeNG doesn't expose an 'activeFocusHoverColor' for p-panelmenu like it does for some other components.
                       As a result, custom CSS is needed to prevent focus/hover styles from applying to active elements.
         */
        const base = `
            .p-panelmenu-header-link {
                font-size: ${primitiveFontTokens.fontSizeL};
                font-weight: 700;
                letter-spacing: 0.25px;
                word-spacing: 2px;
            }

            .p-panelmenu-header:not(.p-disabled) .p-panelmenu-header-content:has(.p-panelmenu-item-link-active):hover .p-panelmenu-header-icon {
                color: ${primitiveColorTokens.white[100]};
            }

            .p-panelmenu-item-link-active,
            .p-panelmenu-item-link-active .p-panelmenu-header-icon {
                color: ${primitiveColorTokens.white[100]};
            }

            .p-panelmenu-item-link-active {
                background-color: ${primitiveColorTokens.blue[700]};
                border-radius: ${primitiveLayoutTokens.borderRadius};
            }
        `;

        return base;
    },
};
